module.exports = __webpack_public_path__ + "img/sungrow.c6ece8d1.webp";